import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "options"];
  static values = {
    referrerKey: String,
    cohortpayHost: String
  };

  connect() {
    this.fetchBatchPaymentReferences();
  }

  async fetchBatchPaymentReferences() {
    try {
      const result = await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        // Avoid CORS issues - use jsonp callback
        const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());

        window[callbackName] = function(data) {
          delete window[callbackName];
          document.body.removeChild(script);
          resolve(data);
        };

        script.src = `${this.cohortpayHostValue}/batch_payment_references.js?callback=${callbackName}&referrer_key=${this.referrerKeyValue}`;
        script.onerror = reject;
        document.body.appendChild(script);
      });

      if (result.permitted) {
        this.containerTarget.classList.remove('hide');
        document.querySelector('li.cohortpay-batch-transaction-option').classList.remove('hide');
        document.querySelector('div.batch-transaction-payment-option').classList.remove('hide');

        this.renderTransactions(result.transactions);
      }
    } catch (error) {
      console.error('Failed to fetch batch payment references:', error);
    }
  }

  renderTransactions(transactions) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    transactions.forEach(payment => {
      const createdAt = new Date(payment.created_at);
      const labelText = `${payment.reference} (created ${createdAt.getDate()} ${monthNames[createdAt.getMonth()]} ${createdAt.getFullYear()})`;

      const radioDiv = `
        <div class="radio">
          <label>
            <input type="radio" name="batch_payment_reference" value="${payment.reference}"/>
            ${labelText}
          </label>
        </div>
      `;
      this.optionsTarget.insertAdjacentHTML('afterbegin', radioDiv);
    });
  }
}
